// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + {"4736":"vendor","7291":"swagger-ui-react"}[chunkId] + "." + {"4736":"0ba22d61","7291":"0d59b5e5"}[chunkId] + ".css";
};